///@ts-nocheck
import React, { useState, useEffect, useCallback, useMemo } from "react";
import {
  Checkbox,
  TextField,
  FormControlLabel,
  Box,
  Chip,
  Autocomplete,
  Popper,
} from "@mui/material";

import { post, get } from "requests";
import CustomModal from "components/CustomModal";
import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import MDButtonRoot from "components/MDButton/MDButtonRoot";
import { Modal, Typography } from "@mui/material";
import EmailPreviewComponent from "./EmailPreviewComponent";
import { useStoreActions, useStoreState } from "easy-peasy";
import { DeleteForever, MailOutlineOutlined } from "@mui/icons-material";
import Offers from "../tabs/underwriting/offers";

interface CheckboxState {
  id: string;
  value: string;
  checked: boolean;
}

interface User {
  name: string;
  email: string;
}

interface SendEmailComponentProps {
  dealApplicationId: any;
  showModal: boolean;
  onClose: () => void;
  onSend: (newValue: string, emailContent: any, sendEmail: boolean, replyOnSameThread: any,recipients: any) => void;
  refresh: () => void;
  topicName: string;
  header: string;
  selected: any[];
  isAutoSubmitted: boolean;
  customTextProps: any;
}

const GenericEmailSenderModal: React.FC<SendEmailComponentProps> = ({
  showModal,
  customTextProps,
  onClose,
  topicName,
  header,
  selected,
  dealApplicationId,
  onSend,
  refresh,
  isAutoSubmitted
}) => {
  const [checkboxes, setCheckboxes] = useState<CheckboxState[]>([
    { id: "funders", value: "Funder", checked: true },
    { id: "merchantOwners", value: "Merchant Owner(s)", checked: true },
    { id: "salesrep", value: "Representative", checked: true },
    { id: "isobroker", value: "ISO/Broker", checked: true },
  ]);

  const [finalEmailRecipients, setFinalEmailRecipients] = useState<User[]>([]);
  const [emailUsers, setEmailUsers] = useState<Record<string, User[]>>({});
  const [newEmail, setNewEmail] = useState("");
  const [additionalDropdownUsers, setAdditionalDropdownUsers] = useState<User[]>([]);
  const [dropDownSelectedUsers, setDropdownSelectedUsers] = useState<User[]>([]);
  const [emailDataComponents, setEmailDataComponents] = useState([]);
  const [selectedEmailComponents, setSelectedEmailComponents] = useState([]);
  const [isEmailEditModal, setIsEmailEditModal] = useState(false);
  const [emailContent, setEmailContent] = useState({});
  const [originalEmailBody, setOriginalEmailBody] = useState({});

  const [isCounterOfferTemplate, setIsCounterOfferTemplate]  = useState<boolean>(topicName === 'event.deal.dealApplication.offers.counter')
  const [customEmailText, setCustomEmailText]  = useState<String>(customTextProps || "");
  const [showSendEmailCheckbox, setShowSendEmailCheckbox]  = useState<boolean>(true);
  const [replyOnSameThread, setReplyOnSameThread] = useState <boolean> (isAutoSubmitted);


   useEffect(() => {
    fetchRecipientsByCategory();
    getAllEmailDetails();
  }, []);

  useEffect(() => {
    const filteredList = dropDownSelectedUsers.filter((user) => {
      const email = user && user.value && user.value.email;
      return !finalEmailRecipients.some((recipient) => recipient.email === email);
    });
    setDropdownSelectedUsers(filteredList);
  }, [finalEmailRecipients]);

  useEffect(() => {
    checkboxes.forEach((checkbox, index) => {
      handleCheckBoxChange(index);
    });
  }, [additionalDropdownUsers]);

  const handleNext = async () => {
    await fetchEmailTemplate();
    setIsEmailEditModal(true);
  };

  const handleBack = async () => {
    setIsEmailEditModal(false);
  };

  const clearAllStates = () => {
    setFinalEmailRecipients([]);
    setSelectedEmailComponents([]);
    onClose();
  };

  const fetchApplicationDeclineReasons = async () => {
    const response = await get("getApplicationDeclineReasons");
    setApplicationDeclineReasons(response);
  };

  const getAllEmailDetails = async () => {
    const response = await post("application/getDataPointsBasedOnTopicName", {
      topicName: topicName,
    });
    const options = Object.keys(response).map((key) => ({
      value: response[key],
      label: key,
    }));
    setSelectedEmailComponents(options);
    setEmailDataComponents(options);
  };

  const fetchRecipientsByCategory = async () => {
    const responseData = await post("fetchRecipientsByCategory", {
      applicationId: dealApplicationId,
    });

    setEmailUsers(responseData);
    setAdditionalDropdownUsers(responseData.users?.filter((usr: User) => usr.email) || []);
    setFinalEmailRecipients(responseData?.defaultRecipients || []);
  };

  const fetchEmailTemplate = async () => {
    const request=
    {
      dealApplicationId: dealApplicationId,
      topicName: topicName,
      offers: selected,
      datapoints: selectedEmailComponents?.map((item) => item.value),
    }

    if(isCounterOfferTemplate && customEmailText){
        request.counterOffer = customEmailText;
    }

    const responseData = await post("getGeneralEmailTemplate",request);
    setEmailContent(responseData);
    setOriginalEmailBody(responseData)
  };


  const handleCheckBoxChange = (index) => {
    const updatedCheckboxes = [...checkboxes];
    updatedCheckboxes[index].checked = !updatedCheckboxes[index].checked;
    setCheckboxes(updatedCheckboxes);
    populateEmailSenders(updatedCheckboxes[index].id);
  };

  const populateEmailSenders = (id) => {
    let recipients = [];
    let recipientsRemoved = [];
    const checkedBox = checkboxes.filter((box) => box.id === id)[0];
    if (checkedBox.checked) {
      const addedUsers = emailUsers && emailUsers[id];
      if (addedUsers) {
        recipients = [...recipients, ...addedUsers.filter((user) => user.email)];
      }
    } else {
      const removedUsers = emailUsers && emailUsers[id];
      if (removedUsers) {
        const checkedUsers = checkboxes
          .filter((box) => box.checked || box.id === id)
          .flatMap((box) => emailUsers[box.id]);
        removedUsers.forEach((eachUser) => {
          const isEmailInList = checkedUsers.some((usr) => usr.email === eachUser.email);
          const isDefaultUser =
            emailUsers &&
            emailUsers.defaultRecipients &&
            emailUsers.defaultRecipients.some((user) => user.email == eachUser.email);
          if (isEmailInList && !isDefaultUser) {
            recipientsRemoved.push(eachUser);
          }
        });
      }
    }
    setFinalEmailRecipients((prevState) => {
      const mergedList = [...prevState, ...recipients].filter(
        (recipient) =>
          !recipientsRemoved.some((removedUser) => removedUser.email === recipient.email)
      );
      const uniqueSet = new Set(mergedList.map((user) => JSON.stringify(user)));
      return Array.from(uniqueSet).map((entry) => JSON.parse(entry));
    });
  };

  const handleAddEmail = useCallback(() => {
    if (!isValidEmail(newEmail)) {
      alert("Please enter a valid email address.");
      return;
    }

    const isDuplicate = finalEmailRecipients.some(
      (recipient) => recipient.email === newEmail.trim()
    );
    if (isDuplicate) {
      alert("This email is already added.");
      return;
    }
    setFinalEmailRecipients((prevState) => [...prevState, { name: "", email: newEmail.trim() }]);
    setNewEmail("");
  }, [newEmail, finalEmailRecipients]);

  const handleSendGenericEmail = async () => {
    const dropDownUsers = dropDownSelectedUsers.map((user) => user && user.value);
    const recipients = [...finalEmailRecipients, ...dropDownUsers];

    if (recipients.length > 0) {
      let params = {
        recipients: finalEmailRecipients,
        emailDetails: emailContent,
        templateName: topicName,
        offerKeys: selected,
        dealApplicationId: dealApplicationId,
      };
      const response = await post("dealApplication/sendCustomEmail", params);
    }
    refresh(dealApplicationId);
    onClose();
  };


    const updateEmailContent = (value: string) => {
      setOriginalEmailBody({
        content: value,
      });
    };

  const prepareContent = (initialContent) => {
    return initialContent;
  };

  const isValidEmail = (email: string) => {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailPattern.test(email);
  };

  const handleRemoveUser = useCallback((index: number) => {
    setFinalEmailRecipients((prevState) => prevState.filter((_, i) => i !== index));
  }, []);

  const handleRemoveDropDownUser = useCallback((index: number) => {
    setDropdownSelectedUsers((prevState) => prevState.filter((_, i) => i !== index));
  }, []);

  const customOptions = useMemo(
    () =>
      additionalDropdownUsers
        .filter((usr) => !finalEmailRecipients.some((recipient) => recipient.email === usr.email))
        .map((usr) => ({
          label: `${usr.name} (${usr.email})`,
          value: usr,
        })),
    [additionalDropdownUsers, finalEmailRecipients]
  );

  const CustomPopper = (props: any) => {
    return (
      <Popper
        {...props}
        placement="bottom-end"
        style={{ zIndex: 1300 }}
        modifiers={[
          {
            name: "preventOverflow",
            enabled: true,
            options: {
              rootBoundary: "document",
            },
          },
          {
            name: "flip",
            enabled: false,
          },
        ]}
      />
    );
  };

  const onSendButtonClick = async (sendEmail: boolean) => {
    if(isCounterOfferTemplate){
          const emailRequest =  {
              content: originalEmailBody?.content,
              subject: emailContent?.subject,
            };

          await onSend(customEmailText,emailRequest,sendEmail,replyOnSameThread,finalEmailRecipients);
    } else{
      await handleSendGenericEmail();
    }
    clearAllStates();
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    setEmailDeclineReason(value);
  };

  const handleSelectChange = (e) => {
    const value = e.target.value;
    setEmailDeclineReason(value);
    setIsDropdownVisible(false);
  };

  return (
    <Modal
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        maxWidth: "600px",
        margin: "auto",
        background: "transparent",
      }}
      open={showModal}
      onClose={clearAllStates}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <MDBox
        display="flex"
        justifyContent="center"
        alignItems="center"
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          padding: "20px",
          backgroundColor: "white",
          borderRadius: "16px",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
        }}
      >
        <MDBox
          sx={{
            background: "white",
            borderRadius: "16px",
            boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
            maxWidth: "md",
            width: "100%",
            padding: 3,
            display: "flex",
            flexDirection: "column",
            gap: 2,
          }}
        >
          <MDBox display="flex" justifyContent="space-between" alignItems="center">
            <MDBox>
              <MDBox display={"flex"} alignItems={"center"}>
                <MailOutlineOutlined />
                <Typography
                  className="decline-modal-header"
                  variant="display1"
                  style={{ marginLeft: "5px" }}
                >
                  {header}
                </Typography>
              </MDBox>
            </MDBox>
            <MDButton onClick={clearAllStates} variant="text" color="secondary">
              X
            </MDButton>
          </MDBox>

          {isEmailEditModal ? (
            <MDBox>
              <EmailPreviewComponent
                htmlContent={prepareContent(emailContent?.content ? emailContent?.content : "")}
                emailBody={emailContent}
                setEmailBody={setEmailContent}
                updateStoreEmailContent={updateEmailContent}
              />
            </MDBox>
          ) : (
            <MDBox sx={{ flex: 1 }}>
              <MDBox>
                {isCounterOfferTemplate && (
                  <MDBox sx={{ mt: 2, mb: 2 }}>
                  
                  <MDTypography variant="subtitle2" fontWeight={"bold"}>
                     COUNTER OFFER <span style={{ color: 'red' }}>*</span>
                   </MDTypography>

                    <TextField
                      autoFocus
                      margin="dense"
                      type="text"
                      fullWidth
                      multiline={true}
                      minRows={2}
                      value={customEmailText}
                      onChange={(e) => setCustomEmailText(e.target.value)}
                    />
                  </MDBox>
                )}

               {isAutoSubmitted && (
                 <FormControlLabel
                  control={
                    <Checkbox
                      checked={replyOnSameThread}
                      onChange={(event) =>{
                        const checked = event?.target?.checked
                        setReplyOnSameThread(checked)
                      }  
                    }  
                    />
                  }
                  label="Send on Same thread"
                />

              )}

       
               {!replyOnSameThread &&
               <MDBox>
                <MDTypography variant="subtitle2" fontWeight={"bold"}>
                  NOTIFICATION RECIPIENTS
                </MDTypography>
                <MDBox sx={{ display: "flex", flexDirection: "row", gap: 1 }}>
                  {checkboxes.map((checkbox, index) => (
                    <FormControlLabel
                      key={checkbox.id}
                      control={
                        <Checkbox
                          checked={checkbox.checked}
                          onChange={() => handleCheckBoxChange(index)}
                        />
                      }
                      label={checkbox.value}
                    />
                  ))}
                </MDBox>

                <MDBox sx={{ mt: 2 }}>
                  <MDTypography variant="subtitle2" fontWeight={"bold"} sx={{ marginBottom: 1 }}>
                    Add Recipients
                  </MDTypography>
                  <Autocomplete
                    multiple
                    disableCloseOnSelect={true}
                    id="search-users"
                    options={customOptions}
                    getOptionLabel={(option) => `${option.label}`}
                    value={dropDownSelectedUsers}
                    onChange={(e, newValue) => setDropdownSelectedUsers(newValue as User[])}
                    renderInput={(params) => <TextField {...params} label="Search Users" />}
                    renderTags={(value, getTagProps) => (
                      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                        {value.map((user, index) => (
                          <Chip
                            key={user?.value?.email}
                            label={`${user?.value?.name} (${user?.value?.email})`}
                            {...getTagProps({ index })}
                          />
                        ))}
                      </Box>
                    )}
                    PopperComponent={CustomPopper}
                  />
                </MDBox>

                <MDBox sx={{ mt: 2 }}>
                  <MDTypography variant="subtitle2" fontWeight={"bold"}>
                    Add Email Address
                  </MDTypography>
                  <MDBox sx={{ display: "flex", gap: 1, mt: 1 }}>
                    <TextField
                      fullWidth
                      type="email"
                      value={newEmail}
                      onChange={(e) => setNewEmail(e.target.value)}
                      placeholder="Enter email address"
                    />
                    <MDButton
                      size="small"
                      color={"primary"}
                      variant="contained"
                      onClick={handleAddEmail}
                    >
                      <MDTypography fontSize={12} color={"white"}>
                        Add
                      </MDTypography>
                    </MDButton>
                  </MDBox>
                </MDBox>

                <MDBox sx={{ mt: 2 }}>
                  <MDTypography variant="subtitle2" fontWeight={"bold"}>
                    Email will be sent to:
                  </MDTypography>
                  <MDBox
                    sx={{ minHeight: 80, maxHeight: 200, overflow: "auto" }}
                    border={1}
                    borderColor={"gray"}
                  >
                    {finalEmailRecipients.map((recipient, index) => (
                      <Chip
                        key={index}
                        label={`${recipient.name} (${recipient.email})`}
                        onDelete={() => handleRemoveUser(index)}
                        sx={{ m: 0.5 }}
                      />
                    ))}
                    {dropDownSelectedUsers.map((user, index) => (
                      <Chip
                        key={index}
                        label={`${user?.value?.name} (${user?.value?.email})`}
                        onDelete={() => handleRemoveDropDownUser(index)}
                        sx={{ m: 0.5 }}
                      />
                    ))}
                  </MDBox>
                </MDBox>

                {!isCounterOfferTemplate && (
                  <MDBox sx={{ mt: 2, mb: 2 }}>
                    <MDTypography marginBottom={3} variant="subtitle2" fontWeight={"bold"}>
                      Information to Send
                    </MDTypography>
                    <Autocomplete
                      multiple
                      disableCloseOnSelect={true}
                      id="search-users"
                      options={emailDataComponents}
                      getOptionLabel={(option) => `${option.label}`}
                      value={selectedEmailComponents}
                      onChange={(e, newValue) => setSelectedEmailComponents(newValue)}
                      renderInput={(params) => <TextField {...params} label="Search Data" />}
                      renderTags={(value, getTagProps) => (
                        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                          {value?.map((datum, index) => (
                            <Chip
                              key={datum?.label}
                              label={datum?.label}
                              {...getTagProps({ index })}
                            />
                          ))}
                        </Box>
                      )}
                      PopperComponent={CustomPopper}
                    />
                  </MDBox>
                )}
                </MDBox>
              }

              </MDBox>
            </MDBox>
          )}
          
          

          <MDBox display="flex" justifyContent="space-between" gap={2}>
            {isEmailEditModal ? (
              <MDButton onClick={handleBack} variant="contained" color="dark" sx={{ flex: 1 }}>
                Back
              </MDButton>
            ) : (
              <MDButton onClick={onClose} variant="contained" color="error" sx={{ flex: 1 }}>
                Cancel
              </MDButton>
            )}

            {!isEmailEditModal && (
              <MDButton
                onClick={() => onSendButtonClick(false)}
                variant="contained"
                color="dark"
                sx={{ flex: 1 }}
                disabled ={isCounterOfferTemplate && !customEmailText }
              >
                Skip & continue
              </MDButton>
            )}

            {isEmailEditModal ? (
              <MDButton
                onClick={() => onSendButtonClick(true)}
                variant="contained"
                color="primary"
                sx={{ flex: 1 }}
              >
                Send
              </MDButton>
            ) : (
              <MDButton onClick={handleNext}
               variant="contained"
                color="primary" 
                sx={{ flex: 1 }} 
              disabled ={isCounterOfferTemplate && !customEmailText }
              >
                Next
              </MDButton>
            )
            }

          </MDBox>
        </MDBox>
      </MDBox>
    </Modal>
  );
};

export default GenericEmailSenderModal;
